/* @flow */

import { compose } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getEventId,
  getEventForgotPasswordURL,
  getEventPasswordFieldType,
  getEventLoginPasswordLabel,
  getEventLoginPasswordLegend,
  getEventLoginPasswordPlaceholder,
  getEventLoginPasswordText,
} from '@e180/domain/lib/event/util';
import {
  getMembershipId,
  isMembershipOnboardingCompleted,
  isMembershipOptInCompleted,
} from '@e180/domain/lib/membership/util';

import LoginPasswordFormDumb from './LoginPasswordFormDumb';
// import LazyPasswordSupportMain from "../support/password/LazyPasswordSupportMain";
import {
  createPassword,
  login,
  resetInitialUrl,
} from 'src/shared/app/authentication/action/base/authenticationActions';
import {
  getAuthenticationUsername,
  isPasswordSet,
  getInitialUrl,
} from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
// import withMount from "../../../base/component/hoc/withMount";
import { throwFormikSubmissionError } from 'src/shared/app/base/form/util/formUtil';
import {
  completeOnboarding,
  completeOnboardingOptimistically,
} from 'src/shared/app/onboarding/action/onboardingActions';
import { isOnboardingCompletedOnDevice } from 'src/shared/app/onboarding/selector/uiOnboardingSelectors';
import { homeRoute } from 'src/shared/app/base/route/setting/routeSettings';
import { getRoutePath } from 'src/shared/app/base/route/util/routeUtils';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  // Self passed
  history: Object,
  intl: intlShape,
};

const mapStateToProps = (state: State, { intl }: Props): Object => {
  const event = getEventSafely(state);
  const { locale } = intl;

  return {
    // $FlowIssue: type only defined for public events
    type: getEventPasswordFieldType(event),
    legend: getEventLoginPasswordLegend(event, locale),
    label: getEventLoginPasswordLabel(event, locale),
    placeholder: getEventLoginPasswordPlaceholder(event, locale),
    note: getEventLoginPasswordText(event, locale),
    isPasswordSet: isPasswordSet(state),
    forgotPasswordURL: getEventForgotPasswordURL(event),
    // Used in `mergeProps` only
    initialUrl: getInitialUrl(state),
    isOnboardingCompleted: isOnboardingCompletedOnDevice(state),
    username: getAuthenticationUsername(state),
    event,
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { history }: Props,
): Object => {
  const {
    isPasswordSet,
    initialUrl,
    isOnboardingCompleted,
    username,
    event,
  } = stateProps;
  const eventId = getEventId(event);

  return {
    ...stateProps,
    // handleMount() {
    //   LazyPasswordSupportMain.preload();
    // },
    handleSubmit({ password }: Object) {
      const action = isPasswordSet ? login : createPassword;

      return dispatch(action(username, password, eventId))
        .then(({ membership }) => {
          if (isOnboardingCompleted) {
            // TODO: merge 2 calls
            dispatch(
              completeOnboardingOptimistically(getMembershipId(membership)),
            );
            dispatch(completeOnboarding(eventId));
          }

          let route = getRoutePath(homeRoute);

          if (
            isMembershipOnboardingCompleted(membership) &&
            isMembershipOptInCompleted(membership) &&
            initialUrl
          ) {
            route = initialUrl;

            dispatch(resetInitialUrl());
          }

          history.push(route);
        })
        .catch((e) => throwFormikSubmissionError(e));
    },
  };
};

export default compose(
  injectIntl,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  // withMount
)(LoginPasswordFormDumb);
